import { Mediator, app, ojs, payload } from "modular-openscriptjs";
import { eParse, approved, inform, processStart, processEnd } from "../helpers";
import { STRINGS, routes, api } from "../declarations";

const broker = app("broker");
const $e = app("$e");

export default class ErrandMediator extends Mediator {
	$$errand = {
		task: {
			needs: {
				completion: (ed, event) => this.completeErrandTask(ed, event),
			},
		},
	};

	async completeErrandTask(ed, event) {
		const data = eParse(ed);

		const { info } = data.message;

		const task = info.task;
		const latitude = info.latitude;
		const longitude = info.longitude;
		const hashtags = info.hashtags;

		if (!approved(event, ed, "You want to mark this task as complete"))
			return;

		let res = await api.post(
			`/riders/errands/${task.order_id}/task/${task.id}/complete`,
			{
				latitude,
				longitude,
				hashtags,
			}
		);

		if (!res) return this.send($e.errand.task.has.completionError, ed);

		inform("Task completed", STRINGS.SUCCESS);

		this.send($e.errand.task.is.completed, payload({ task }));

		this.send($e.order.needs.refresh, payload({ orderId: task.order_id }));
	}
}
